import { Modal as AntdModal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@components/shared';
import useAnalytics from '@shared/useAnalytics';
import { PARAMETERS } from '@root/tracking/constants';
import routes from '@root/routes';
import useEnv from '@shared/useEnv';
import styles from './SignUpModal.module.less';

type Props = {
  isOpen: boolean;
};

const SignUpModal = ({ isOpen }: Props) => {
  const { t } = useTranslation('listing');
  const { vtsUrl } = useEnv();
  const { clickToPage, anonymousId } = useAnalytics();

  return (
    <AntdModal
      className={styles.modal}
      wrapClassName={styles.modalWrap}
      visible={isOpen}
      closable={false}
      footer={null}
      width={435}
      maskStyle={{ backdropFilter: 'blur(8px)' }}
    >
      <div className={styles.headerImage}></div>
      <div className={styles.content}>
        <h2 className={styles.wantToViewMore}>{t('signUpModal.wantToViewMore')}</h2>
        <h3 className={styles.createFreeAccount}>{t('signUpModal.createFreeAccount')}</h3>

        <ul className={styles.bulletpoints}>
          <li>{t('signUpModal.searchInventory')}</li>
          <li>{t('signUpModal.tourSpaces')}</li>
          <li>{t('signUpModal.buildTourbooks')}</li>
          <li>{t('signUpModal.canvass')}</li>
        </ul>
        <div className={styles.buttonWrapper}>
          <ButtonLink
            className={styles.button}
            type="primary"
            size="large"
            onClick={() => {
              clickToPage({
                destination: PARAMETERS.signUpPage,
                sourcePage: PARAMETERS.listingPage,
                sourceContent: PARAMETERS.paywallPrompt,
              });
            }}
            href={routes.signUp(vtsUrl!, {
              utm_content: 'paywall prompt',
              utm_term: 'listing page',
              anonymous_id: anonymousId,
            })}
          >
            {t('signUpModal.button')}
          </ButtonLink>
        </div>
        <p className={styles.loginPrompt}>
          {t('signUpModal.loginPrompt')}&nbsp;
          <a href="/login">{t('signUpModal.loginLinkTitle')}</a>
        </p>
      </div>
    </AntdModal>
  );
};

export default SignUpModal;
